import { useDevices } from 'app/agriculture/queries/devices/useDevices';
import { useMemo } from 'react';

interface QueryParams {
    deviceId: string;
}

export function useDevice({ deviceId }: QueryParams) {
    const devices = useDevices();

    return useMemo(() => {
        const device = devices.get(deviceId);

        if (!device) {
            throw new Error(`No device found for deviceId: ${deviceId}`);
        }

        return device;
    }, [devices, deviceId]);
}
